export enum LegalPersonState {
  none = "none",
  finished = "finished"
}

export default LegalPersonState;
